<template>
	<div
		id="header"
		class="w-full flex pt-4 pb-3 px-4 gap-5"
	>
		<div class="w-auto flex flex-col items-center gap-2">
			<template v-if="exihibit_avatar">
				<img
					id="img-avatar"
					:src="exihibit_avatar"
					class="rounded-lg"
					style="height: 113px; width: 113px; object-fit: cover"
					@click="ShowPhotoModal"
				/>
			</template>
			<template v-else>
				<button
					type="button"
					class="btn btn-photo"
					style=""
					@click="ShowPhotoModal"
				>
					<i class="far fa-user mx-5 my-2 font-20"></i>
				</button>
			</template>

			<button
				type="button"
				class="btn"
				@click="UploadAvatar"
			>
				SELECIONAR
			</button>
			<input
				id="input-avatar"
				type="file"
				accept=".jpg, .jpeg, .png"
				hidden
				@change="UploadAvatar($event)"
			/>
		</div>

		<div class="w-full">
			<h4 class="font-24 font-md-32 mb-4">
				{{ patient?.nome_paciente ?? 'DESCONHECIDO' }}
			</h4>
			<div class="w-full flex items-center gap-6">
				<div class="flex items-center gap-2">
					<label class="mb-0 font-bold text-dark">DOCUMENTO</label>
					<span> {{ patient?.id ? document : 'DESCONHECIDO' }}</span>
				</div>

				<div class="flex items-center gap-2">
					<label class="mb-0 font-bold text-dark"
						>CADASTRAMENTO</label
					>
					<span>
						{{ signin_date }}
					</span>
				</div>
			</div>
		</div>

		<template v-if="patient?.patient_code">
			<div class="flex flex-col items-center gap-2">
				<a
					:href="patientPortalUrl"
					rel="noopener"
					target="_blank"
					style="
						border: 1px solid var(--hr);
						padding: 0.5rem;
						border-radius: 1rem;
						background-color: #fff;
					"
				>
					<qrcode-vue
						:text="patientPortalUrl"
						:size="95"
						class="max-100 rounded-lg"
					/>
				</a>
				<button
					class="btn btn-light-primary mx-0"
					style="display: block; margin: 0 auto"
					@click="PrintQRCode"
				>
					IMPRIMIR
				</button>
			</div>
		</template>

		<div
			id="modal-webcam"
			class="modal fade"
		>
			<div
				class="modal-dialog mw-100 d-flex justify-content-center align-items-center"
			>
				<div class="modal-content">
					<button
						id="close-modal"
						class="btn btn-light btn-sm"
						@click="ClosePhotoModal"
					>
						<i class="fal fa-times"></i>
					</button>
					<div class="modal-header px-5 py-4 mt-5 mt-sm-1">
						<h4 class="font-20 m-0 text-center">
							REGISTRAR A FOTO DO PACIENTE
						</h4>
					</div>
					<div
						class="modal-body d-flex flex-column align-items-center"
					>
						<div
							v-if="webcam.snap"
							id="img-snapped"
						>
							<img
								:src="webcam.snap"
								width="100%"
								alt="Foto do paciente"
							/>
						</div>
						<WebCam
							v-show="!webcam.snap"
							id="webcam"
							ref="webcam"
							:device-id="deviceId"
							screenshot-format="image/png"
							width="100%"
							height="100%"
							@cameras="onCameras"
							@camera-change="onCameraChange"
						>
						</WebCam>

						<span
							v-if="!camera && !webcam.snap"
							class="align-self-center"
						>
							AGUARDE A IMAGEM DA CÂMERA APARECER...
						</span>
						<button
							class="btn btn-light my-4"
							@click="SnapPhoto"
						>
							{{
								webcam.snap ? 'TIRAR OUTRA FOTO' : 'TIRAR FOTO'
							}}
						</button>
						<span class="mb-4 text-success"
							>* PARA ACEITAR A FOTO QUE FOI TIRADA BASTA FECHAR
							ESSA JANELA *</span
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	import { WebCam } from 'vue-web-cam'
	import QrcodeVue from 'vue-qrcode-component'
	import { mapGetters } from 'vuex'

	export default {
		name: 'PatientIdentification',
		components: {
			WebCam,
			QrcodeVue,
		},
		props: {
			patient: {
				type: [Object, null],
				default: null,
			},
		},
		data() {
			return {
				exihibit_avatar: '',
				webcam: {
					ready: false,
					mode: 'user',
					snap: null,
				},
				camera: null,
				deviceId: null,
				devices: [],
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
			today() {
				return moment().format('DD/MM/YYYY')
			},
			signin_date() {
				if (!this.patient?.created_at) return this.today

				let data = this.patient.created_at.substr(0, 10)

				data = data.split('-').reverse().join('/')

				return data
			},
			document() {
				if (!this.patient?.doc) return 'DESCONHECIDO'

				let doc = this.patient.doc_id

				return `${doc.tipo} - ${doc.numero}`
			},
			device: function () {
				return this.devices.find(n => n.deviceId === this.deviceId)
			},
			patientPortalUrl() {
				const base =
					process && process.env && process.env.VUE_APP_PORTAL_URL
						? process.env.VUE_APP_PORTAL_URL
						: ''

				if (!this.patient) return ''

				const code = this.patient.patient_code || ''

				return `${base.replace(
					/\/$/,
					''
				)}/resultados?codigo=${encodeURIComponent(code)}`
			},
		},
		watch: {
			'patient.avatar': {
				handler(val) {
					if (val) {
						if (val instanceof File) {
							const reader = new FileReader()
							reader.onload = e => {
								this.exihibit_avatar = e.target.result
							}
							reader.readAsDataURL(val)
						} else {
							this.exihibit_avatar = val
						}
					}
				},
				immediate: true,
			},
			camera(id) {
				this.deviceId = id
			},
			devices() {
				const [first, ...tail] = this.devices

				if (first) {
					this.camera = first.deviceId
					this.deviceId = first.deviceId
				}
			},
		},
		methods: {
			async ShowPhotoModal() {
				window.jQuery('#modal-webcam').modal({
					backdrop: false,
					show: true,
				})

				this.webcam.ready = true
				this.$refs.webcam.start()

				window.jQuery('body').addClass('modal-open')

				this.webcam.snap = this.patient?.avatar ?? null
			},
			SnapPhoto() {
				if (this.webcam.snap) {
					this.webcam.snap = null
					this.$refs.webcam.start()
					return
				}

				this.webcam.snap = this.$refs.webcam.capture()
			},
			async ClosePhotoModal() {
				this.$emit(
					'on-update-avatar',
					this.webcam.snap || this.patient?.avatar
				)

				window
					.jQuery('#modal-webcam')
					.modal('hide')
					.on('hidden.bs.modal', () => {
						this.$refs.webcam.stop()
						this.webcam.ready = false

						//GAMBITECH
					})
			},
			onCameras(cameras) {
				this.devices = cameras
			},
			onCameraChange(deviceId) {
				this.deviceId = deviceId
			},
			UploadAvatar(event) {
				if (event.target.files) {
					const reader = new FileReader()
					const file = event.target.files[0]

					if (file) {
						this.$emit('on-update-avatar', null)
						this.$emit('on-update-avatar', file)
						reader.onload = e => {
							this.exihibit_avatar = e.target.result
						}
						reader.readAsDataURL(file)
					}
				}

				document.querySelector('#input-avatar').click()
			},
			PrintQRCode() {
				const url = `/paciente/imprimir?patient_id=${this.patient.id}&account_id=${this.requester_selected_id}`

				const print = window.open(url, '_blank')
				if (print) {
					print.mainWindow = window
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	#header {
		border-bottom: 1px solid var(--elementsBorderColor);

		.btn.btn-photo {
			height: 113px;
			width: 113px;
			border-radius: 1rem;
			background-color: var(--white);
			border-color: black;
			color: black;
		}

		#img-avatar {
			cursor: pointer;
		}

		#webcam,
		#img-snapped,
		#img-avatar {
			width: 100%;
		}

		#close-modal {
			position: absolute;
			right: 15px;
			top: 15px;
		}

		@media (min-width: 575.98px) {
			.modal-content {
				width: 75% !important;
			}
		}

		@media (min-width: 1000px) {
			.modal-content {
				max-width: 50% !important;
			}
		}

		@media (min-width: 1500px) {
			.modal-content {
				max-width: 800px !important;
			}
		}
	}
</style>
